import React from 'react';
import { theme, style, FAIL, PENDING, SUCCESS, LOADING } from 'constants';
import { Link, Text, View, StatusBox } from 'core';
import * as actions from 'actions';

const styles = style({
  item: {
    flexDirection: 'row',
    marginVertical: 10,
    alignItems: 'center'
  },
  item_text: {
    color: theme.gray_color_lighten(0.8)
    // fontSize: 12
  },
  status: {
    marginHorizontal: 5,
    fontSize: theme.font_sm
  },
  gray_color_lighten: {
    color: theme.gray_color_lighten(0.4)
  },
  error: {
    color: theme.error_color
  },
  success: {
    color: theme.success_color
  },
  cancel: {
    marginLeft: 'auto'
  },
  img_progress_container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  }
});

export const FileStatus = (file, is_image) => {
  const result = {
    [PENDING]: <Text style={[styles.gray_color_lighten, styles.status]}>(pending)</Text>,
    [LOADING]: <Text style={[styles.gray_color_lighten, styles.status]}>{file.total ? Math.floor(100 * file.loaded / file.total) : 0}%</Text>,
    [FAIL]: <Text style={[styles.error, styles.status]}>error</Text>,
    [SUCCESS]: is_image ? <Text /> : <Text style={styles.success}>100%</Text>
  };
  return result[file.status];
};
const uploadItem = (file, id, style) => {
  return (
    <View key={id} style={[styles.item, style]}>
      <Text numberOfLines={1} ellipsizeMode={'tail'} style={styles.item_text}>
        {file.name}
      </Text>
      {FileStatus(file)}
      <Link title=" X" style={styles.cancel} onPress={() => actions.cancelUpload({ file_id: file.file_id })} />
    </View>
  );
};

export const UploadList = ({ files, style, item_style }) =>
  files && files.length ? <View style={style}>{files.map((file, index) => uploadItem(file, index, item_style))}</View> : null;

export const ImageProgress = ({ file, status, onSuccess, style }) => {
  const file_status = FileStatus(file, true);
  return file_status ? (
    <View style={[styles.img_progress_container, style]}>
      {status ? <StatusBox status={status} onSuccess={onSuccess} color="white" /> : null}
      {file_status}
    </View>
  ) : null;
};



// WEBPACK FOOTER //
// ./src/components/core/upload_progress.js